<template>
  <div class="round-box" :class="[zsTjTheme]">
    <div class="title">
      <img v-if="zsTjTheme == 'dark'" class="icon" src="@/assets/zs_imgs/battle-title-icon.png" alt="" />
      <img v-if="zsTjTheme == 'light'" class="icon" src="@/assets/zs_imgs/light-battle-title-icon.png" alt="" />
      <span>阵容搭配</span>
      <el-button
        v-if="isEdit"
        type="primary"
        class="btn normal-btn"
        style="font-size: 12px;width: 80px;margin-left: 10px;"
        @click="handleEditTeam"
        >编辑队伍</el-button
      >
    </div>
    <div class="round-container">
      <div
        v-for="item in filterRoundData"
        :key="item.index"
        :class="['round-item', item.index === value ? 'active' : '']"
        @click="handleClick(item.index)"
      >
        {{ item.label }}
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  props: {
    isEdit: {
      type: Boolean,
      default: false
    },
    value: {
      type: Number,
      default: 0
    },
    roundInfos: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapGetters(["zsTjTheme"]),
    filterRoundData() {
      if (this.isEdit || (this.loginUser && this.loginUser.is_super)) {
        return this.round;
      }
      return this.round;
    }
  },
  data() {
    return {
      round: [
        { label: "推图", index: 0 },
        { label: "PVP", index: 1 },
        { label: "BOSS", index: 2 }
      ]
    };
  },
  methods: {
    handleClick(index) {
      this.$emit("change", index);
    },
    handleEditTeam() {
      this.$emit("editTeam");
    }
  }
};
</script>

<style lang="less" scoped>
.btn {
  height: 28px;
  padding: 0;
  line-height: 28px;
  font-size: 14px;
  color: #fff;
  background-color: #5889d4;
  border-color: transparent;
  &.is-disabled {
    background-color: #a0a0a0;
  }
}
.normal-btn {
  background: #56677d;
  &.is-disabled {
    background-color: #a0a0a0;
  }
}
.round-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .title {
    display: flex;
    align-items: center;
    color: #fff;
    font-weight: bold;
    font-size: 18px;
    .icon {
      width: 22px;
      height: 22px;
      margin-right: 5px;
    }
  }
  .round-container {
    display: flex;
    align-items: center;
    user-select: none;
    padding: 6px 4px;
    margin-right: 12px;
    border-radius: 4px;
    background: rgba(0, 0, 0, 0.3);
    box-sizing: border-box;

    .round-item {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      padding: 8px 16px;
      border-radius: 4px;
      color: #ccc;
      font-size: 12px;
      cursor: pointer;
      transition: all 0.3s;
      &.active {
        color: #fff;
        background: #3b4655;
      }
    }
  }
}

.round-box.light {
  .title {
    color: #333333;
  }

  .round-container {
    background: rgba(57, 89, 101, 0.15);
    .round-item {
      color: rgba(51, 51, 51, 0.6);
      &.active {
        color: #fff;
        background: #474c4f;
      }
    }
  }
}
</style>
